/* DataExplorer.js */

"use strict";
const Registrations = require("../../RegistrationNamespaces");

module.exports = {
    name: "data_explorer",
    label: "Data Explorer",
    disabled: false,
    order: 9, // Depricated -- Newer solution uses order from index.js
    app: "GameConsole",
    section: "GameCenter",
    license: ["GLUWARE"],
    accessPerm: ["dataExplorerAccess"],
    pageTitle: "Gluware Data Manager",
    helpLink: "Data%20Explorer/Create-report-template.htm",
    navIcon: "dataexplorer.solution",
    iconName: "dataexplorer.solution",
    lmrbNamespaces: [
        Registrations.DATA_EXPLORER_DEVICE_EXPLORER_ENTITY_LMRB,
        Registrations.DATA_EXPLORER_IOT_DEVICE_EXPLORER_ENTITY_LMRB,
        Registrations.DATA_EXPLORER_LMRB,
    ],
    editorNamespaces: [Registrations.DATA_INSTANCE_EDITOR],
    dataExplorer: {
        viewNamespaces: [
            Registrations.DATA_EXPLORER_SWITCH_TO_DEVICE_EXPLORER,
            Registrations.DATA_EXPLORER_GRID,
            Registrations.DATA_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER,
        ],
        actionNamespaces: [
            Registrations.DATA_EXPLORER_ACTIONS_CREATE,
            Registrations.DATA_EXPLORER_ACTIONS_DELETE,
            Registrations.DATA_EXPLORER_ACTIONS_CLONE,
            Registrations.DATA_EXPLORER_ACTIONS_EXPORT,
            Registrations.DATA_EXPLORER_ACTIONS_IMPORT,
        ],
    },
    deviceExplorer: {
        viewNamespaces: [
            Registrations.DATA_EXPLORER_DEVICE_VIEW_GRID,
            Registrations.DEVICE_EXPLORER_SWITCH_TO_DATA_EXPLORER,
            Registrations.DEVICE_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER,
        ],
        actionNamespaces: [
            Registrations.DEVICE_EXPLORER_ACTION_ADHOC_QUERY,
            Registrations.DEVICE_EXPLORER_ACTION_EXPORT,
        ],
    },
    iotDeviceExplorer: {
        viewNamespaces: [
            Registrations.IOT_DEVICE_EXPLORER_VIEW_GRID,
            Registrations.IOT_SWITCH_TO_DEVICE_EXPLORER,
            Registrations.IOT_SWITCH_TO_DATA_EXPLORER,
        ],
        actionNamespaces: [Registrations.IOT_DEVICE_EXPLORER_ACTION_EXPORT],
    },
    dataEditor: {
        viewNamespaces: [
            Registrations.DEIE_VIEW_DETAILS,
            Registrations.DEIE_VIEW_ACTIVITY,
            Registrations.DEIE_VIEW_RESULT,
        ],
        actionNamespaces: [],
    },
    deviceEditor: {
        viewNamespaces: [Registrations.DIE_VIEW_DETAILS, Registrations.DIE_VIEW_ACTIVITY],
        actionNamespaces: [Registrations.DIE_ACTION_DELETE],
    },
    navOptions: {
        device: {
            name: "Devices",
            options: {
                exp: "device",
            },
            type: "exp",
        },
        iot_device: {
            name: "IoT Devices",
            options: {
                exp: "iot_device",
            },
            type: "exp",
        },
        template_explorer: {
            name: "Template Library",
            options: {
                exp: "template",
            },
            type: "exp",
        },
    },
};
